export const getWorkPhone = (
  mobileNumberValue: string | null,
  extValue: string | null
): string => {
  const extPart = extValue ? `Ext ${extValue}` : '';

  if (!mobileNumberValue) {
    return extPart;
  }

  const output = `${mobileNumberValue} ${extPart}`;
  return output;
};
